const baseUrl = {
	urlMottu: 'https://attendance-totem-bff.mottu.cloud/api',
};

export const environment = {
	urlMottu: 'https://attendance-totem-bff.mottu.cloud/api',
	operationBffUrl: `https://maintenance-operation-bff.mottu.cloud`,
	flagsmithEnvId: 'oEuidwgfXRHw3cZTFt2jPX',
	enableObservability: true,
	enableServiceWorker: true,

	state: {
		production: true,
		homolog: false,
		development: false,
	},

	keycloak: {
		url: 'https://sso.mottu.cloud',
		realm: 'Internal',
		clientId: 'attendance-totem-front-client',
	},

	apiUrl: {
		v2: {
			payment: `${baseUrl.urlMottu}/finance`,
		},
		v3: {
			newUrlMottu: `${baseUrl.urlMottu}`,
			totem: `${baseUrl.urlMottu}/totem`,
			userMottu: `${baseUrl.urlMottu}/user`,
			totemMottuCity: `${baseUrl.urlMottu}/v2/totemmottucity`,
			attendence: `${baseUrl.urlMottu}/attendance`,
			attendenceV2: `${baseUrl.urlMottu}/v2/attendance`,
			onboarding: `${baseUrl.urlMottu}/onboarding`,
			scheduling: `${baseUrl.urlMottu}/scheduling`,
		},
	},

	typeformApi: {
		widgets: {
			quizMottuCity: 'cT2HU785',
			motorcyclePickup: 'SAJXWX6Z',
		},
	},
};
